<template>
    <div class="tw:bg-white tw:rounded-xl tw:shadow-sm tw:border tw:border-gray-100 tw:overflow-hidden">
        <div class="tw:bg-linear-to-r tw:from-emerald-600 tw:to-emerald-500 tw:px-6 tw:py-4">
            <h3 class="tw:text-base tw:font-semibold tw:text-white tw:tracking-wide tw:flex tw:items-center tw:gap-2">
                <i class="fas fa-user tw:opacity-80"></i>
                Datos personales
            </h3>
        </div>

        <div class="tw:p-6 tw:space-y-5">
            <div class="tw:bg-emerald-50 tw:border tw:border-emerald-100 tw:rounded-lg tw:p-4">
                <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                    <DataField 
                        icon="fas fa-id-card"
                        label="Nombre completo" 
                        :value="`${abonado.name} ${abonado.surnames}`"
                        labelClass="tw:text-emerald-400"
                        valueClass="tw:text-emerald-900"
                    />
                    <DataField 
                        icon="fas fa-tag"
                        label="Nº de abonado" 
                        :value="abonado.n_abonado"
                        labelClass="tw:text-emerald-400"
                        valueClass="tw:text-emerald-900"
                    />
                    <DataField 
                        icon="fas fa-history"
                        label="Nº antiguo" 
                        :value="abonado.n_abonado_antiguo"
                        labelClass="tw:text-emerald-400"
                        valueClass="tw:text-emerald-900"
                    />
                    <DataField 
                        icon="fas fa-venus-mars"
                        label="Género" 
                        :value="abonado.genero"
                        labelClass="tw:text-emerald-400"
                        valueClass="tw:text-emerald-900"
                    />
                </div>
            </div>

            <div v-if="!manager.lfp" class="tw:border-t tw:border-gray-100"></div>

            <div v-if="!manager.lfp" class="tw:space-y-5">
                <!-- Contact Data -->
                <div class="tw:space-y-3">
                    <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                        <i class="fas fa-phone"></i> Datos de contacto
                    </p>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <DataField icon="fas fa-phone-alt" label="Teléfono" :value="abonado.telefono" />
                        <DataField v-if="tieneMovil" icon="fas fa-mobile-alt" label="Móvil" :value="abonado.movil" />
                        <DataField icon="fas fa-envelope" label="Email" :value="abonado.email" wrapperClass="tw:md:col-span-2" />
                    </div>
                </div>

                <div class="tw:border-t tw:border-gray-100"></div>

                <!-- Personal Data -->
                <div class="tw:space-y-3">
                    <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                        <i class="fas fa-file-alt"></i> Datos personales adicionales
                    </p>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <DataField icon="fas fa-birthday-cake" label="Fecha de nacimiento" :value="abonado.fecha_nacimiento" />
                        <DataField icon="fas fa-id-badge" label="DNI" :value="abonado.dni" />
                    </div>
                </div>

                <div class="tw:border-t tw:border-gray-100"></div>

                <!-- Address -->
                <div class="tw:space-y-3">
                    <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                        <i class="fas fa-map-marker-alt"></i> Domicilio
                    </p>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <DataField icon="fas fa-home" label="Dirección" :value="abonado.domicilio" wrapperClass="tw:md:col-span-2" />
                        <DataField icon="fas fa-envelope" label="CP" :value="abonado.cp" />
                        <DataField icon="fas fa-building" label="Localidad" :value="abonado.localidad" />
                        <DataField icon="fas fa-map" label="Provincia" :value="abonado.provincia" />
                        <DataField icon="fas fa-globe" label="País" :value="abonado.pais" />
                    </div>
                </div>

                <div class="tw:border-t tw:border-gray-100"></div>

                <!-- Employment -->
                <div class="tw:space-y-3">
                    <p class="tw:text-xs tw:font-semibold tw:text-gray-400 tw:uppercase tw:tracking-wider tw:flex tw:items-center tw:gap-1">
                        <i class="fas fa-briefcase"></i> Datos laborales
                    </p>
                    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                        <DataField icon="fas fa-user-tie" label="Penista" :value="abonado.penista" />
                        <DataField icon="fas fa-building" label="Empresa" :value="abonado.empresa" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
    import DataField from '@/modules/admin/ui/DataField.vue'
    import { computed } from 'vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        },
        manager: {
            type: Object,
            default: () => ({})
        }
    })
    const tieneMovil = computed(() => {
        const movil = props.abonado.movil
        return movil != null && movil !== '' && movil !== 0 && movil !== '0'
    })
</script>
